import React from 'react'

interface DumbbellIconProps {
  className?: string;
}

const DumbbellIcon: React.FC<DumbbellIconProps> = ({ className }) => {
  return (
    <svg  width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.64 14.2599L6.5 15.2099L10.52 11.1899L2.52 6.5999L3.68 5.4399C3.78 5.3399 3.94 5.2999 4.09 5.3399L13.39 8.3199C14.97 6.7399 16.54 5.1199 18.16 3.5699C18.47 3.2399 18.86 2.9899 19.32 2.8399C19.77 2.6799 20.19 2.5699 20.57 2.4999C21.12 2.4499 21.55 2.8999 21.5 3.4299C21.43 3.8099 21.32 4.2299 21.16 4.6799C21.01 5.1399 20.76 5.5299 20.43 5.8399L15.68 10.6199L18.65 19.9099C18.7 20.0599 18.65 20.1999 18.55 20.3199L17.38 21.4799L12.81 13.4599L8.8 17.4999L9.75 20.3399L8.6 21.4999L6.12 17.8799L2.5 15.3999L3.64 14.2599Z" fill="#1E293B"/>
    </svg>
  )
}

export default DumbbellIcon



